import TextComponent from 'common-components/Text'

import styled, { css } from 'styled-components'
import { COLORS } from 'consts/colors'

export const FlatTab = styled.div<{
  $tabWidth: number
  $isActive: boolean
  $isRTLDirection: boolean
  $areHoverStylesUnset?: boolean
}>`
  width: ${props => `${props.$tabWidth}px`};
  position: relative;
  cursor: pointer;
  text-align: center;

  display: flex;
  justify-content: center;
  align-items: center;

  /* Hover emphasis for inactive tabs only — the active tab keeps its primary tint. */
  ${({ $areHoverStylesUnset, $isActive }) =>
    !$areHoverStylesUnset &&
    !$isActive &&
    css`
      &:hover {
        p {
          color: ${COLORS.textPrimary};
        }
        path {
          fill: ${COLORS.textPrimary};
        }
      }
    `}
`

export const Text = styled(TextComponent)<{
  $isActive: boolean
}>`
  position: absolute;
  z-index: 2;
  ${props =>
    props.$isActive &&
    css`
      cursor: default;
      pointer-events: none;
    `}
`

// Icon-only (or icon + text) tab content. Sits above the sliding active
// indicator (z-index 2, matching Text). The active icon is tinted primary to
// mirror the active text color; inactive keeps the icon's own fill, and the
// FlatTab hover rule recolors the path on hover.
export const IconWrap = styled.div<{
  $isActive: boolean
}>`
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  path {
    fill: ${COLORS.textSecondary};
  }

  ${props =>
    props.$isActive &&
    css`
      pointer-events: none;
      path {
        fill: ${COLORS.primary};
      }
    `}
`
